import {
  FeatureFlag,
  isFeatureFlagOn,
} from "@/organization/providers/OrganizationProvider"
import type { Organization } from "@/query/graphql"

export function shouldShowActiveDelegates(
  organization?: Organization | null,
): boolean {
  if (!organization) {
    return false
  }

  return (
    isFeatureFlagOn(
      organization?.features,
      FeatureFlag.DisplayDelegatesStatusLabel,
    ) ?? false
  )
}
